import { Translation } from '@ps/web-shared-components';

import type { Maybe } from '@swf/generated/graphql/sports/schemas';

import { TXTWCL_Less_than_1X } from './FormatEventStatusDuration.messages.json';

interface Props {
  intervalInSeconds: Maybe<number> | number | undefined;
  prefix?: string;
  suffix?: string;
  isCountdownTimer?: boolean;
}

const FormatEventStatusDuration: React.FC<Props> = ({
  intervalInSeconds,
  prefix = ' - ',
  suffix = '’',
  isCountdownTimer = false
}) => {
  if (!intervalInSeconds) return '';
  const minutes = Math.floor(intervalInSeconds / 60);

  if (minutes === 0 && isCountdownTimer) {
    return (
      <>
        {prefix}
        <Translation {...TXTWCL_Less_than_1X} />
      </>
    );
  }

  return `${prefix}${minutes}${suffix}`;
};

export default FormatEventStatusDuration;
